export default "__VITE_ASSET__C$uT5wOt__"